import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../services/authentication.service';
import { CommonService } from '../../../services/common.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-profile-myprofile',
  templateUrl: './profile-myprofile.component.html',
    styleUrls: ['./profile-myprofile.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ProfileMyprofileComponent implements OnInit {

    public url: any;
    public isProfile = false;
    public isMutualFriend = false;
    public isActiveFeed = false;
    public isIntroProfile = false;
    public isFollowers = false;
    public isFollowings = false;
    public isLatestPhotos = false;
    public isFriends = false;

    public active = 1;

    pagecode: string = "my-profile";
    module: string = "profile";
    accessdenied: boolean = false;

    constructor(private sanitizer: DomSanitizer, private route: ActivatedRoute,
        private router: Router,
        public authentication: AuthenticationService,
        private common: CommonService) {

        //this.userData = this.authentication.userData;
        //this.myId = this.authentication._authentication.id;

    }

    //Fileupload
    readUrl(event: any) {
        if (event.target.files.length === 0)
            return;
        //Image upload validation
        var mimeType = event.target.files[0].type;
        if (mimeType.match(/image\/*/) == null) {
            return;
        }
        // Image upload
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (_event) => {
            this.url = reader.result;
        }
    }

    ngOnInit() {
        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {

                        var pageURL = this.router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                    }
                    else {
                        this.accessdenied = true;
                    }
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });
    }
    editProfile() {
        this.router.navigate(['/profile/edit']);
    }
    changePassword() {
        this.router.navigate(['/profile/changePassword']);
    }
    changeProfilePicture() {
        this.router.navigate(['/profile/changeProfilePicture']);

    }
}
